import { Button, CircularProgress, Typography } from '@mui/material'
import { type SVGProps } from 'react'

export function AIButton({
  loading,
  onClick,
  children,
  disabled,
}: {
  loading?: boolean
  onClick: () => void
  children: React.ReactNode
  disabled?: boolean
}) {
  return (
    <Button
      disabled={disabled}
      startIcon={loading ? <CircularProgress size={20} /> : <AIGenerateIcon />}
      sx={{
        position: 'relative',
        borderRadius: '12px',
        background: '#FFF',
        border: '1px solid transparent',
        backgroundClip: 'padding-box',
        opacity: disabled ? 0.4 : 1,
        height: 36,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '-1px',
          left: '-12px',
          right: '-12px',
          bottom: '-1px',
          borderRadius: '16px',
          padding: '1px',
          background: 'linear-gradient(45deg, #FF6C6C, #DD7BFF)',
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'destination-out',
          maskComposite: 'exclude',
          pointerEvents: 'none',
        },
      }}
      onClick={onClick}
    >
      <Typography
        fontWeight={500}
        sx={{
          textTransform: 'none',
          backgroundColor: '#fff',
          color: 'transparent',
          backgroundImage: 'linear-gradient(45deg, #FF6C6C 0%, #DD7BFF 100%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}
      >
        {children}
      </Typography>
    </Button>
  )
}

function AIGenerateIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={21} viewBox="0 0 21 21" width={21} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#a)">
        <path
          d="M15.51 6.754V2.587m-10.834 15v-4.166m8.75-8.75h4.167m-15 10.833H6.76M5.51 1.754 4.856 3.06c-.221.443-.332.664-.48.856a2.5 2.5 0 0 1-.453.454c-.192.147-.413.258-.856.48l-1.307.653 1.307.654c.443.22.664.331.856.48a2.5 2.5 0 0 1 .453.453c.148.192.259.413.48.855l.654 1.308.653-1.308c.222-.442.332-.663.48-.855a2.5 2.5 0 0 1 .454-.454c.192-.148.413-.258.855-.48l1.308-.653-1.308-.654c-.442-.221-.663-.332-.855-.48a2.5 2.5 0 0 1-.454-.453c-.148-.192-.258-.413-.48-.856zm8.75 8.333-.793 1.585c-.221.443-.332.664-.48.856a2.5 2.5 0 0 1-.453.454c-.192.147-.413.258-.856.48l-1.585.792 1.585.793c.443.22.664.331.856.48q.255.197.454.453c.147.192.258.413.48.855l.792 1.586.792-1.586c.222-.442.332-.663.48-.855q.198-.256.454-.454c.191-.148.413-.258.855-.48l1.585-.792-1.585-.793c-.442-.22-.664-.332-.855-.48a2.5 2.5 0 0 1-.454-.453c-.148-.192-.258-.413-.48-.856z"
          stroke="url(#b)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.667}
        />
      </g>
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="b" x1={1.76} x2={18.426} y1={18.421} y2={1.754}>
          <stop stopColor="#FF6C6C" />
          <stop offset={1} stopColor="#DD7BFF" />
        </linearGradient>
        <clipPath id="a">
          <path d="M.093.086h20v20h-20z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}
